<template>
    <Header></Header>
    <div class="container _mypage sub_page">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_02 _small"><img src="img/b_icon_02.png" /></i>
                <i class="deco_03 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_04 _small"><img src="img/b_icon_03.png" /></i>

                <i class="deco_character"><img src="img/mypage_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>마이페이지</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <ul>
                    <li @click="changeType(0)"><a href="javascript:void(0)">회원정보수정</a></li>
                    <li @click="changeType(1)" class="active"><a href="javascript:void(0)">1:1 문의</a></li>
                    <li @click="changeType(2)"><a href="javascript:void(0)">내가 쓴 게시글</a></li>
                    <li @click="changeType(3)"><a href="javascript:void(0)">신청내역</a></li>
                </ul>
            </div>
        </section>

        <section class="sub_page_con wrap_1120 mypage_inqury">
            <div class="bread_crumbs">
                <a href="" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></a>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="마이페이지" /></span>
                <a href="">마이페이지</a>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="1:1문의하기" /></span>
                <a href="">1:1문의하기</a>
            </div>
            <div class="sub_con_tit">1:1 문의 보내기</div>
            <div class="sub_page_con_view con_write">
                <ul class="flex_column">
                    <li>
                        <label for="title" class="">제목</label>
                        <input id="title" type="text" v-model="form_state.title" placeholder="제목을 입력하세요" />
                    </li>
                    <li>
                        <label for="content" class="">내용</label>
                        <textarea name="" id="content" class="custom_scroll" v-model="form_state.content" placeholder="내용을 입력하세요"></textarea>
                    </li>
                </ul>
                <div class="btn_wrap _default">
                    <button class="common_btn _gray w_180" @click="router.go(-1)">취소</button>
                    <button class="common_btn w_180" @click="write">작성완료</button>
                </div>
            </div>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <Footer></Footer>
</template>
<script lang="ts" config>
    import { Header, Footer, reactive, router, onMounted, ModalDefault, types, apiService, getMessageByCode } from "@/BaseComponent";

    export default {
        components: { ModalDefault, Header, Footer },
        emits: ["emit"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const form_state = reactive({
                title: "",
                content: "",
            });

            onMounted(() => {});

            const write = async () => {
                if (!form_state.title) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "제목을 입력해 주세요.";
                    state.isShowModal = true;
                } else if (!form_state.content) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "내용을 입력해 주세요.";
                    state.isShowModal = true;
                } else {
                    const param: types.ReqInquiry = {
                        title: form_state.title,
                        content: form_state.content,
                    };
                    let res: types.BaseResponse = await apiService.mypage.inquiryAdd(param);
                    if (res.returnCode === 0) {
                        state.modalTab = 7;
                        state.modalTitle = "알림";
                        state.modalContent = "등록 되었습니다.";
                        state.isShowModal = true;
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = (param: any) => {
                if (param.action === "callback") {
                    state.isShowModal = false;
                    router.push({ path: "/mypage", query: { type: 1 } });
                }
            };

            const changeType = (type: number) => {
                router.push({ path: "/mypage", query: { type: type } });
            };

            return { router, state, form_state, closeModal, callBackModal, write, emit, changeType };
        },
    };
</script>
